"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**************************************** PROJECT MODULES *****************************************/
var record_1 = require("../model/record");
var date_time_all_1 = require("../date/date-time-all");
/************************************* INSTANTIATING RECORDS **************************************/
/**
 * Given a set of user data & schedules object, extract matching record
 *
 * Uses Default Constructor for when the user creates a record on the client,
 * with input validation
 *
 * Event: broadcast:CREATE:{record}
 *        Record creation triggers 'broadcast:CREATE:{record}' event, which gets
 *        handled by JavelinImpl#broadcast, & broadcast methods on the managers
 *        (data manager & sync manager)
 *        This event saves the record to the inner db
 *
 * @param firstName    Record's first name
 * @param lastName     Record's last name (optional in some cases)
 * @param gender       Record's gender
 * @param birthdate    Record's birthdate
 * @param region       Record's region
 * @param scheduleId   Id of the Record's [Schedule] (optional in some cases)
 * @param relationship User's relationship with the record
 * @param doctor       Record's doctor (optional)
 * @param cityId       Id of the Record's [City], null if none
 * @param notes        User inputted notes for this record
 * @param consentDate  Date user consented to being able to keep this record
 * @param {RegionAbbrevId} region Location (mainly province) that record
 *                                correpsonds to e.g. `on`, `sk`
 *
 * @throws DisplayException Thrown if there's an error with the inputted info
 */
exports.getRecordFromSchedules = function (schedules) { return function (firstName, lastName, gender, // 0 | 1 | 2
birthdate, relationship, drName, cityId, notes, consentDate, region) {
    // Find schedule with matching region
    var matchSchedule = schedules.find(function (sch) { return sch.region.toUpperCase() === region.toUpperCase(); });
    // If no schedule with matching region found, throw error
    if (!schedules || !matchSchedule)
        throw new Error("getRecordFromSchedules :: Schedule with the " +
            ("expected region \"" + region + "\" not found, among schedule(s): " + schedules));
    var emptyRecord = Object.create(record_1.Record.prototype);
    // Build & save new record object
    // This automatically triggers a `broadcast:CREATE:{recordId}`
    // event, which is then automatically handled by the data managers
    var record = new record_1.Record_init_client(emptyRecord);
    record.saveRecord(firstName, lastName, gender, birthdate, matchSchedule.region, matchSchedule.scheduleId, relationship, drName, cityId, notes, consentDate, true);
    // Set the record object's "last updated" time/date to "right now"
    record.lastUpdated = date_time_all_1.ZonedDateTime.new();
    return record;
}; };
//# sourceMappingURL=records.js.map